export interface SecurityInsight {
  id: string
  notificationId: string
  type: number
  targetUrl: string
  data: any
}

export const SecurityInsightType = {
  MoreWorkSimple: 1, // もっと働きたいかどうかシンプルに聞く
  UndesiredWorkCondition: 2, // 望ましくない勤務条件
}

export interface UndesiredWorkConditionData {
  coWorker: string | null
  workSite: string | null
  businessDivision: string[]
  distance: number | null
  numberOfCoWorkers: 'alone' | 'multi' | null
  numberOfCoWorkersDetail: number | null
  pattern: 'fixed' | 'fluid' | null
  other: string | null
}
